import { render, staticRenderFns } from "./SingleTarget.vue?vue&type=template&id=271d8528&scoped=true"
import script from "./SingleTarget.vue?vue&type=script&lang=js"
export * from "./SingleTarget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "271d8528",
  null
  
)

export default component.exports